import { motion } from "framer-motion"
import { useLanguageStore } from "../../state-management/languageStore"

const DateInfoDiv = () => {
    const t = useLanguageStore((state) => state.translate)
    return (
        <div className="mx-auto flex flex-col justify-center items-center pb-8 w-full relative">
            <div className="relative space-y-4">
                <h2 className="text-primary-50 text-3xl font-semibold flex items-center gap-2">
                    <span className="px-2 relative">
                        {t("home.dateLabel")}
                        <svg
                            className="absolute -bottom-3 rotate-2 left-1 w-[110%]"
                            viewBox="0 0 204 17"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <motion.path
                                initial={{ pathLength: 0, opacity: 0 }}
                                animate={{ pathLength: 1, opacity: 1 }}
                                transition={{ delay: 0.5, duration: 0.5 }}
                                d="M1.89551 13.8813C28.0526 13.8813 54.5029 12.1528 80.5604 9.89891C85.494 9.47216 99.9091 6.9044 95.3839 8.9156C91.4628 10.6583 87.3629 12.0414 83.3629 13.5863C81.4973 14.3069 74.3515 16.0696 82.1829 15.3809C122.46 11.8386 162.584 6.2415 202.786 1.93408"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    </span>
                </h2>
                <h2 className="text-primary-50 text-3xl font-semibold flex items-center gap-2">
                    <span className="px-2 relative">
                        {t("home.timeLabel")}
                        <svg
                            className="absolute -bottom-6 left-0 w-[110%] rotate-3"
                            viewBox="0 0 165 26"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <motion.path
                                initial={{ pathLength: 0, opacity: 0 }}
                                animate={{ pathLength: 1, opacity: 1 }}
                                transition={{ delay: 1.5, duration: 0.5 }}
                                d="M1.89551 16.6253C11.3814 15.9869 20.8549 14.8938 30.3624 14.6096C32.3825 14.5492 37.2552 13.6823 36.3606 15.4945C35.597 17.0414 30.861 18.6399 29.4774 19.2311C26.1148 20.6681 22.633 21.7842 19.1772 22.9677C13.9849 24.7459 20.9843 23.9296 22.3976 23.7544C55.4768 19.6522 87.8787 10.8781 120.876 6.12849C135.145 4.07463 149.528 2.76534 163.847 1.13818"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                            />
                        </svg>
                    </span>
                </h2>
            </div>
        </div>
    )
}

export default DateInfoDiv
